import { ORB_FILL, ORB_VIEW_BOX } from '@nula/core-ui';

interface NulaOrbProps {
  size?: number;
  className?: string;
}

/**
 * The Nula emblem. Single source of truth: the smooth ORB_FILL path + viewBox
 * from core-ui (themed via --primary). Do NOT inline a copy of the path here —
 * core-ui owns the brand mark so every surface stays in lockstep.
 */
export function NulaOrb({ size = 18, className }: NulaOrbProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={ORB_VIEW_BOX}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="nula-orb"
      className={className}
    >
      <path fill="var(--primary)" d={ORB_FILL} />
    </svg>
  );
}
